import { createSlice } from "@reduxjs/toolkit";

const productReducer = createSlice({
    name: 'robotixProducts',
    initialState: {
        robotixProducts: [],
        isFetching: false,
        error: false,
    },

    reducers: {
        // Get All Product
        getRobotixProductStart: (state) => {
            state.isFetching = true;
        },
        getRobotixProductSuccess: (state, action) => {
            state.isFetching = false;
            state.robotixProducts = action.payload;
        },
        getRobotixProductFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        }
    }
});

export const { getRobotixProductStart, getRobotixProductSuccess, getRobotixProductFailure } = productReducer.actions;
export default productReducer.reducer;